import { get } from '../../shared/services/http.service';
import { QueryParams } from '../../shared/models/query-params.model';

export const getConversationHistory = async (userId: string, params: QueryParams) => {
  return get(`/conversations/${userId}`, { params });
};

export default getConversationHistory;
